import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createCustomShiftNotification } from 'api/shifts/createCustomShiftNotification'
import { customShiftNotificationsKey } from './keys'

type CreateCustomShiftNotificationRequest = Omit<
  Parameters<typeof createCustomShiftNotification>[0],
  'shiftId'
>

export const useCreateCustomShiftNotificationMutation = (shiftId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CreateCustomShiftNotificationRequest) =>
      createCustomShiftNotification({ shiftId, ...data }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: customShiftNotificationsKey(shiftId),
      })
    },
  })
}
